import React, { Fragment, FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import CalculatedPaymentInline from "Shared/CalculatedPaymentInline";
import styled from "styled-components";

const CompleteLinkContainer = styled("div")`
    text-align: right;
`;

const CompleteLink = styled("a")`
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    text-decoration: underline;
`;

interface Props {
    onGoToCreditApp: () => void;
}

const CreditSkipped: FunctionComponent<Props & WithTranslation> = ({ onGoToCreditApp, t }) => {
    return (
        <Fragment>
            <p className="StepOne__title">{t("ContinueDeal.StepOne.CreditSkipped.title")}</p>
            <p className="StepOne__text">
                {t("ContinueDeal.StepOne.CreditSkipped.description1")}
                <CalculatedPaymentInline />
                {t("ContinueDeal.StepOne.CreditSkipped.description2")}
            </p>
            <br />
            <CompleteLinkContainer>
                <CompleteLink onClick={onGoToCreditApp}>
                    {t("ContinueDeal.StepOne.CreditSkipped.completeCreditAppButtonLabel")}
                </CompleteLink>
            </CompleteLinkContainer>
        </Fragment>
    );
};

export default withTranslation()(CreditSkipped);
